var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"active":!_vm.isDisabled,"label":_vm.isPinned ? _vm.$t('_action.unpin_from_top') : _vm.$t('_action.pin_to_top'),"position":"is-left"}},[_c('b-button',{class:[
      (_vm.isDisabled || _vm.isUpdating) && 'has-cursor-not-allowed',
      _vm.isPinned && 'has-text-info',
      !_vm.isPinned && 'has-text-grey-lighter'
    ],style:({ textDecoration: 'none' }),attrs:{"icon-right":"thumbtack","type":"is-white"},on:{"click":function($event){_vm.isDisabled ? function () {} : _vm.$emit('togglePinned')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }